<!-- CONTAINER -->
<div class="bg-white py-36px px-24px rounded-tl-[24px] rounded-tr-[24px]">
	<!-- HEADER SECTION -->
	<!-- <h2>
		{{ 'CLIENT.CLIENT_LIST.TITLE' | translate }}
	</h2> -->
	<!-- filter -->
	<app-search-filter
		(toggleFilter)="sidenav.toggle()"
		(keyWord)="
			clientFilter.searchText = $event;
			clientFilter.paging.pageNumber = 1;
			getClints()
		"
		(resetFilter)="filter.resetFilter()"
		searchKey="BOOKING.BOOKING_LIST.SEARCH"
		[filterCount]="filterCount"
	></app-search-filter>

	<!-- table -->
	<app-client-table
		(actionChanged)="getClints()"
		[clients]="clients"
		[clientFilter]="clientFilter"
		[totalCount]="totalCount"
	></app-client-table>

	<!-- no data found -->
	<app-no-data-found
		*ngIf="!clients?.length"
		[imageName]="'profile-2user.svg'"
		[text]="'CLIENT.CLIENT_LIST.NO_RESULT_FOUND'"
	></app-no-data-found>
</div>

<!-- pagination -->
<div class="mt-8 py-5 max-mobile:overflow-auto">
	<app-pagination
		[totalCount]="totalCount"
		[pageNumber]="clientFilter.paging.pageNumber"
		[pageCount]="clientFilter.paging.pageSize"
		(currentPage)="pageChanged($event, clientFilter.paging.pageSize)"
		(itemsCountPerPage)="pageChanged(1, $event)"
	></app-pagination>
</div>

<ng-container>
	<mat-sidenav-container [hasBackdrop]="true" class="z-20">
		<mat-sidenav
			position="end"
			#sidenav
			mode="side"
			opened
			class="w-[428px] bg-white text-dark-grey p-12px min-h-screen"
			[fixedInViewport]="true"
			[fixedTopGap]="0"
			[disableClose]="false"
			[fixedBottomGap]="0"
			[disableClose]="false"
			[opened]="false"
		>
			<header class="tw-p-4 p-12px">
				<div class="rtl:text-left ltr:text-right">
					<button (click)="sidenav.toggle()">
						<img src="./assets/images/close-square.svg" alt="" />
					</button>
				</div>
			</header>
			<app-client-filter
				#filter
				[filterData]="clientFilter"
				(emitFilter)="getClints(true, $event); sidenav.toggle()"
				(emitFilterCount)="filterCount = $event"
			></app-client-filter>
		</mat-sidenav>
	</mat-sidenav-container>
</ng-container>

<!-- fixed button -->
<!--
#TODO: Uncomment when we make add client 
-->
<!-- <app-fixed-button
	[buttonWidth]="240"
	[buttonTitle]="'CLIENT.CLIENT_LIST.ADD_CLIENT'"
	[imgPath]="'add-white.svg'"
>
</app-fixed-button> -->
